module.exports = __webpack_public_path__ + "media/customizations/ryeranchlife/logo-new-ae1bfc7889e778fb7659484db90179af.png";